import { Route, Routes } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NavBar from "./components/NavBar";
import Login from "./components/Login";
import ContractorHome from "./components/ContractorHome";
import ContractorAccount from "./components/ContractorAccount";
import Support from "./components/Support";
import Ownerhome from "./components/Ownerhome";
import CvAdmin from "./components/Admin";
import AddProject from "./components/AddProject";
import InspectorHome from "./components/InspectorHome";
import AddUser from "./components/AddUser";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Register from "./components/Register";
import RegisterForm from "./components/RegisterForm";
import ViewUsers from "./components/ViewUsers";
import NewUserApproval from "./components/NewUserApproval";

const Routers = () => {
  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});

  const isLogin = Boolean(cookies.sessionid);
  const isLoginAsSessionStorage = Boolean(localStorage.getItem("userData"));
  const userdata = JSON.parse(localStorage.getItem("userData"));
  // userdata.role = "Inspector";

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register-form" element={<RegisterForm />} />


      {isLogin && isLoginAsSessionStorage ? (
        userdata?.role === "Contractor" ? (
          <Route path="/" element={<NavBar />}>
            <Route path="/contractor" element={<ContractorHome />} />
            <Route path="/account" element={<ContractorAccount />} />
            <Route path="/support" element={<Support />} />
            <Route path="/AddProject" element={<AddProject />} />
            <Route path="/*" element={<Navigate replace to="/login" />} />
          </Route>
        ) : userdata?.role === "Owner" ? (
          <Route path="/" element={<NavBar />}>
            <Route path="/owner" element={<Ownerhome />} />
            <Route path="/account" element={<ContractorAccount />} />
            <Route path="/support" element={<Support />} />
            <Route path="/*" element={<Navigate replace to="/login" />} />
          </Route>
        ) : userdata?.role === "Admin" ? (
          <Route path="/" element={<NavBar />}>
            <Route path="/admin" element={<CvAdmin />} />
            {/* <Route path="/createuser" element={<AddUser />} /> */}
            <Route path="/viewusers" element={<ViewUsers />} />

            <Route path="/support" element={<Support />} />
            <Route path="/*" element={<Navigate replace to="/login" />} />
          </Route>
        ) : userdata?.role === "Inspector" ? (
          <Route path="/" element={<NavBar />}>
            <Route path="/inspector" element={<InspectorHome />} />
            <Route path="/support" element={<Support />} />
            <Route path="/*" element={<Navigate replace to="/login" />} />
          </Route>
        ) : (
          <Navigate replace to="/login" />
        )
      ) : (
        <Route path="/*" element={<Navigate replace to="/login" />} />
      )}
    </Routes>
  );
};

export default Routers;
